import { GMapsInput } from "@components/common/inputs/GMapsInput";
import {
  DSDropdown,
  DSInput,
} from "@components/design-system/molecules";
import { formatPhoneNumberForInput } from "@src/utils/phoneUtils";
import { useEffect, useRef } from "react";
import { Controller } from "react-hook-form";

import { ContactType } from "./constants/ContactType";

const CONTACT_TYPE_OPTIONS = [
  { label: "Email", value: ContactType.EMAIL },
  { label: "Phone Call", value: ContactType.CALL },
  { label: "Text Message", value: ContactType.TEXT },
  { label: "Snail Mail", value: ContactType.SNAIL_MAIL },
  { label: "Carrier Pigeon", value: ContactType.CARRIER_PIGEON },
];

export default function GetStartedContactInfo({
  control,
  register,
  contactType,
  userEmail,
  setValue,
}) {
  const prevContactTypeRef = useRef(contactType);
  useEffect(() => {
    const prevContactType = prevContactTypeRef.current;
    if (
      [ContactType.CALL, ContactType.TEXT].includes(contactType) &&
      [ContactType.CALL, ContactType.TEXT].includes(prevContactType)
    ) {
      prevContactTypeRef.current = contactType;
      return;
    }
    setValue(
      "contactInfo",
      contactType === ContactType.EMAIL ? userEmail : null,
    );
    prevContactTypeRef.current = contactType;
  }, [contactType, setValue, userEmail]);

  function formPlaceholderForContactType(contactType) {
    if (contactType === ContactType.EMAIL) {
      return "Enter your email";
    }

    if (
      contactType === ContactType.CALL ||
      contactType === ContactType.TEXT
    ) {
      return "(555) 444-7890";
    }
    return "";
  }
  return (
    <>
      <div className="space-y-4">
        <div className="flex flex-row items-center">
          <DSDropdown
            options={CONTACT_TYPE_OPTIONS}
            value={contactType}
            onChange={(value) => {
              setValue("contactType", value);
            }}
            placeholder="Sort by..."
            width="w-full"
            dataTestId="contact-type-dropdown"
          />
        </div>
        <div className="flex flex-row items-center">
          <div className="text-m leading-none ml-2">
            What's the best way to contact you?
          </div>
        </div>
        <div className="flex flex-row items-center">
          {contactType === ContactType.SNAIL_MAIL ||
          contactType === ContactType.CARRIER_PIGEON ? (
            <Controller
              control={control}
              name="address"
              render={({ field: { ref, onChange, value } }) => {
                return (
                  <div className="w-full">
                    <GMapsInput
                      updateBillingAddress={() => {}}
                      inputRef={ref}
                      value={value}
                      onChange={onChange}
                    />
                  </div>
                );
              }}
            />
          ) : (
            <DSInput
              type="text"
              placeholder={formPlaceholderForContactType(contactType)}
              dataTestId={"contactInfo"}
              {...register("contactInfo", {
                onBlur: (e) => {
                  if (
                    contactType === ContactType.CALL ||
                    contactType === ContactType.TEXT
                  ) {
                    const formatted = formatPhoneNumberForInput(
                      e.target.value,
                    );
                    e.target.value = formatted;
                  }
                },
              })}
            />
          )}
        </div>
      </div>
    </>
  );
}
